// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-axios';
import type { GetAffiliateCommissionsData, GetAffiliateCommissionsResponse, GetAffiliateCustomersData, GetAffiliateCustomersResponse, UpdateAffiliateCustomerFeeData, UpdateAffiliateCustomerFeeResponse, PostAffiliateUserData, PostAffiliateUserError, PostAffiliateUserResponse, GetAnalyticsForPayoutsGraphData, GetAnalyticsForPayoutsGraphResponse, GetPayoutsSummaryData, GetPayoutsSummaryResponse, GetCustomerApiCredentialsData, GetCustomerApiCredentialsError, GetCustomerApiCredentialsResponse, PostCustomerApiCredentialsData, PostCustomerApiCredentialsError, PostCustomerApiCredentialsResponse, PatchCustomerApiCredentialsData, PatchCustomerApiCredentialsError, PatchCustomerApiCredentialsResponse, GetBankAccountsData, GetBankAccountsError, GetBankAccountsResponse, PatchBankAccountData, PatchBankAccountError, PatchBankAccountResponse, GetBankAccountByPayoutIdData, GetBankAccountByPayoutIdError, GetBankAccountByPayoutIdResponse, GetCompliancePackageRequestsData, GetCompliancePackageRequestsResponse, PostCompliancePackageRequestData, PostCompliancePackageRequestResponse, DownloadCompliancePackageData, DownloadCompliancePackageResponse, GetCustomerSettingsData, GetCustomerSettingsResponse, PatchCustomerSettingsData, PatchCustomerSettingsResponse, GetCustomersData, GetCustomersError, GetCustomersResponse, PatchCustomerData, PatchCustomerResponse, CreateCustomerData, CreateCustomerError, CreateCustomerResponse, GetCustomerByIdData, GetCustomerByIdError, GetCustomerByIdResponse, GetDepositsData, GetDepositsError, GetDepositsResponse, PatchDepositData, PatchDepositError, PatchDepositResponse, GetFeesData, GetFeesResponse, GetFilesByCustomerIdData, GetFilesByCustomerIdResponse, UploadFileData, UploadFileResponse, GenerateHdfcIrmReportData, GenerateHdfcIrmReportResponse, GenerateHdfcRequestLetterData, GenerateHdfcRequestLetterResponse, CreateInvoicePreviewData, CreateInvoicePreviewResponse, DeleteFileByIdData, DeleteFileByIdError, DeleteFileByIdResponse, GetFileByIdData, GetFileByIdResponse, GetFileContentByIdData, GetFileContentByIdResponse, GetIdentityVerificationsData, GetIdentityVerificationsResponse, PostIdentityVerificationData, PostIdentityVerificationResponse, PatchIdentityVerificationQueryDocumentsData, PatchIdentityVerificationQueryDocumentsResponse, GetIdentityVerificationDetailsByIdData, GetIdentityVerificationDetailsByIdResponse, PatchVerificationFlowSubmissionData, PatchVerificationFlowSubmissionResponse, PatchVerificationStepDataData, PatchVerificationStepDataResponse, GetInvoicesData, GetInvoicesResponse, CreateInvoiceData, CreateInvoiceError, CreateInvoiceResponse, PostInvoiceOverdueReminderData, PostInvoiceOverdueReminderError, PostInvoiceOverdueReminderResponse, GetInvoiceByPayoutIdData, GetInvoiceByPayoutIdError, GetInvoiceByPayoutIdResponse, GetInvoiceByIdData, GetInvoiceByIdError, GetInvoiceByIdResponse, UpdateInvoiceByIdData, UpdateInvoiceByIdError, UpdateInvoiceByIdResponse, PostMultiCurrencyEnableData, PostMultiCurrencyEnableError, PostMultiCurrencyEnableResponse, GetCurrencyWalletsData, GetCurrencyWalletsResponse, PostCurrencyWalletData, PostCurrencyWalletResponse, GetBeneficialOwnersData, GetBeneficialOwnersResponse, PostBeneficialOwnerData, PostBeneficialOwnerResponse, DeleteBeneficialOwnerData, DeleteBeneficialOwnerResponse, PatchBeneficialOwnerData, PatchBeneficialOwnerError, PatchBeneficialOwnerResponse, GetPartnersData, GetPartnersError, GetPartnersResponse, CreatePartnerData, CreatePartnerError, CreatePartnerResponse, GetPartnerByIdData, GetPartnerByIdResponse, UpdatePartnerData, UpdatePartnerError, UpdatePartnerResponse, GetPayoutsData, GetPayoutsResponse, PostPayoutsData, PostPayoutsError, PostPayoutsResponse, PostPayoutsPreviewData, PostPayoutsPreviewResponse, GenerateBankDetailsPdfData, GenerateBankDetailsPdfError, GenerateBankDetailsPdfResponse, PostContactFormData, PostContactFormError, PostContactFormResponse, GetGenericFeesData, GetGenericFeesError, GetGenericFeesResponse, GetCostsFromFircData, GetCostsFromFircError, GetCostsFromFircResponse, GetFircUploadResponseByIdData, GetFircUploadResponseByIdError, GetFircUploadResponseByIdResponse, GetEmailUnsubscribeStatusData, GetEmailUnsubscribeStatusError, GetEmailUnsubscribeStatusResponse, PostEmailUnsubscribeData, PostEmailUnsubscribeError, PostEmailUnsubscribeResponse, GetPurposeCodesData, GetPurposeCodesError, GetPurposeCodesResponse, PostPurposeCodesData, PostPurposeCodesError, PostPurposeCodesResponse, GetUsersData, GetUsersError, GetUsersResponse, PatchUserData, PatchUserResponse, GetOrCreateUserData, GetOrCreateUserError, GetOrCreateUserResponse, GetUserByEmailData, GetUserByEmailError, GetUserByEmailResponse, SyncUserData, SyncUserError, SyncUserResponse, DeleteUserData, DeleteUserError, DeleteUserResponse, GetUserByIdData, GetUserByIdError, GetUserByIdResponse, GetNfcCardDetailsData, GetNfcCardDetailsError, GetNfcCardDetailsResponse, CreateOrUpdateNfcCardData, CreateOrUpdateNfcCardError, CreateOrUpdateNfcCardResponse, SendOtpData, SendOtpResponse, VerifyOtpData, VerifyOtpError, VerifyOtpResponse, PostXflowWebhookData, PostXflowWebhookError, PostXflowWebhookResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * Get affiliate user's commissions
 */
export const getAffiliateCommissions = <ThrowOnError extends boolean = false>(options: Options<GetAffiliateCommissionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAffiliateCommissionsResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/affiliate/commissions'
    });
};

/**
 * Get affiliate linked customers
 */
export const getAffiliateCustomers = <ThrowOnError extends boolean = false>(options: Options<GetAffiliateCustomersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAffiliateCustomersResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/affiliate/customers'
    });
};

/**
 * Update affiliate customer fee details
 */
export const updateAffiliateCustomerFee = <ThrowOnError extends boolean = false>(options: Options<UpdateAffiliateCustomerFeeData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateAffiliateCustomerFeeResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/affiliate/customers/{cid}'
    });
};

/**
 * Mark an existing user as an affiliate partner
 */
export const postAffiliateUser = <ThrowOnError extends boolean = false>(options: Options<PostAffiliateUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostAffiliateUserResponse, PostAffiliateUserError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/affiliate/users'
    });
};

/**
 * Get Analytics
 */
export const getAnalyticsForPayoutsGraph = <ThrowOnError extends boolean = false>(options: Options<GetAnalyticsForPayoutsGraphData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAnalyticsForPayoutsGraphResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/analytics/payouts_graph'
    });
};

/**
 * Get payouts summary with analytics
 */
export const getPayoutsSummary = <ThrowOnError extends boolean = false>(options: Options<GetPayoutsSummaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPayoutsSummaryResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/analytics/payouts_summary'
    });
};

/**
 * List programmatic API credentials for a customer
 */
export const getCustomerApiCredentials = <ThrowOnError extends boolean = false>(options: Options<GetCustomerApiCredentialsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCustomerApiCredentialsResponse, GetCustomerApiCredentialsError, ThrowOnError>({
        ...options,
        url: '/api/v1/api-credentials'
    });
};

/**
 * Create programmatic API credentials for a customer
 */
export const postCustomerApiCredentials = <ThrowOnError extends boolean = false>(options: Options<PostCustomerApiCredentialsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCustomerApiCredentialsResponse, PostCustomerApiCredentialsError, ThrowOnError>({
        ...options,
        url: '/api/v1/api-credentials'
    });
};

/**
 * Perform lifecycle operations on programmatic API credentials for a customer
 */
export const patchCustomerApiCredentials = <ThrowOnError extends boolean = false>(options: Options<PatchCustomerApiCredentialsData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchCustomerApiCredentialsResponse, PatchCustomerApiCredentialsError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/api-credentials/{api_key}'
    });
};

/**
 * Get bank account details
 */
export const getBankAccounts = <ThrowOnError extends boolean = false>(options: Options<GetBankAccountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetBankAccountsResponse, GetBankAccountsError, ThrowOnError>({
        ...options,
        url: '/api/v1/bank_accounts'
    });
};

/**
 * Update bank account
 */
export const patchBankAccount = <ThrowOnError extends boolean = false>(options: Options<PatchBankAccountData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchBankAccountResponse, PatchBankAccountError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/bank_accounts/{bank_account_id}'
    });
};

/**
 * Get bank account details linked to Payout ID
 */
export const getBankAccountByPayoutId = <ThrowOnError extends boolean = false>(options: Options<GetBankAccountByPayoutIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetBankAccountByPayoutIdResponse, GetBankAccountByPayoutIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/bank_accounts/{payout_id}'
    });
};

/**
 * Get compliance package requests for customer
 */
export const getCompliancePackageRequests = <ThrowOnError extends boolean = false>(options: Options<GetCompliancePackageRequestsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCompliancePackageRequestsResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/compliance-package'
    });
};

/**
 * Create compliance package download request
 */
export const postCompliancePackageRequest = <ThrowOnError extends boolean = false>(options: Options<PostCompliancePackageRequestData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCompliancePackageRequestResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/compliance-package'
    });
};

/**
 * Download the compliance package file
 */
export const downloadCompliancePackage = <ThrowOnError extends boolean = false>(options: Options<DownloadCompliancePackageData, ThrowOnError>) => {
    return (options?.client ?? client).get<DownloadCompliancePackageResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/compliance-package/{request_id}/download'
    });
};

/**
 * Get Customer Settings
 */
export const getCustomerSettings = <ThrowOnError extends boolean = false>(options: Options<GetCustomerSettingsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCustomerSettingsResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/customer_settings'
    });
};

/**
 * Patch Customer Settings
 */
export const patchCustomerSettings = <ThrowOnError extends boolean = false>(options: Options<PatchCustomerSettingsData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchCustomerSettingsResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/customer_settings'
    });
};

/**
 * Get Customers by search
 */
export const getCustomers = <ThrowOnError extends boolean = false>(options: Options<GetCustomersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCustomersResponse, GetCustomersError, ThrowOnError>({
        ...options,
        url: '/api/v1/customers'
    });
};

/**
 * Update Customer As Default
 */
export const patchCustomer = <ThrowOnError extends boolean = false>(options: Options<PatchCustomerData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchCustomerResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/customers'
    });
};

/**
 * Create Customer
 */
export const createCustomer = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateCustomerResponse, CreateCustomerError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/customers'
    });
};

/**
 * Get Customer by Id
 */
export const getCustomerById = <ThrowOnError extends boolean = false>(options: Options<GetCustomerByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCustomerByIdResponse, GetCustomerByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/customers/{id}'
    });
};

/**
 * Get Deposits
 */
export const getDeposits = <ThrowOnError extends boolean = false>(options: Options<GetDepositsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDepositsResponse, GetDepositsError, ThrowOnError>({
        ...options,
        url: '/api/v1/deposits'
    });
};

/**
 * Move deposit to Partner Vban
 */
export const patchDeposit = <ThrowOnError extends boolean = false>(options: Options<PatchDepositData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchDepositResponse, PatchDepositError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/deposits/{deposit_id}'
    });
};

/**
 * Get Payout Fee details
 */
export const getFees = <ThrowOnError extends boolean = false>(options: Options<GetFeesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFeesResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/fees'
    });
};

/**
 * List documents for a customer excluding logo, profile picture, and additional invoice documents
 */
export const getFilesByCustomerId = <ThrowOnError extends boolean = false>(options: Options<GetFilesByCustomerIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFilesByCustomerIdResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/files'
    });
};

/**
 * Upload File content
 */
export const uploadFile = <ThrowOnError extends boolean = false>(options: Options<UploadFileData, ThrowOnError>) => {
    return (options?.client ?? client).post<UploadFileResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/octet-stream',
            ...options?.headers
        },
        url: '/api/v1/files'
    });
};

/**
 * Generate HDFC IRM Excel report
 */
export const generateHdfcIrmReport = <ThrowOnError extends boolean = false>(options: Options<GenerateHdfcIrmReportData, ThrowOnError>) => {
    return (options?.client ?? client).post<GenerateHdfcIrmReportResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        responseType: 'blob',
        url: '/api/v1/files/hdfc-irm'
    });
};

/**
 * Generate HDFC Request Letter
 */
export const generateHdfcRequestLetter = <ThrowOnError extends boolean = false>(options: Options<GenerateHdfcRequestLetterData, ThrowOnError>) => {
    return (options?.client ?? client).post<GenerateHdfcRequestLetterResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        responseType: 'blob',
        url: '/api/v1/files/hdfc-letter'
    });
};

/**
 * Create Invoice PDF file for preview
 */
export const createInvoicePreview = <ThrowOnError extends boolean = false>(options: Options<CreateInvoicePreviewData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateInvoicePreviewResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        responseType: 'blob',
        url: '/api/v1/files/invoice-preview'
    });
};

/**
 * Deletes the file by id
 */
export const deleteFileById = <ThrowOnError extends boolean = false>(options: Options<DeleteFileByIdData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteFileByIdResponse, DeleteFileByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/files/{file_id}'
    });
};

/**
 * Get File Details By ID
 */
export const getFileById = <ThrowOnError extends boolean = false>(options: Options<GetFileByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFileByIdResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/files/{file_id}'
    });
};

/**
 * Get File content By ID
 */
export const getFileContentById = <ThrowOnError extends boolean = false>(options: Options<GetFileContentByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFileContentByIdResponse, unknown, ThrowOnError>({
        ...options,
        responseType: 'blob',
        url: '/api/v1/files/{file_id}/content'
    });
};

/**
 * List identity verifications for admin review
 */
export const getIdentityVerifications = <ThrowOnError extends boolean = false>(options: Options<GetIdentityVerificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetIdentityVerificationsResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/identity_verifications'
    });
};

/**
 * To Start the Verification Data capturing
 */
export const postIdentityVerification = <ThrowOnError extends boolean = false>(options: Options<PostIdentityVerificationData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostIdentityVerificationResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/identity_verifications'
    });
};

/**
 * Submit a compliance document for an identity verification query
 */
export const patchIdentityVerificationQueryDocuments = <ThrowOnError extends boolean = false>(options: Options<PatchIdentityVerificationQueryDocumentsData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchIdentityVerificationQueryDocumentsResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/identity_verifications/queries/{verification_id}/'
    });
};

/**
 * Get the Verification data By ID
 */
export const getIdentityVerificationDetailsById = <ThrowOnError extends boolean = false>(options: Options<GetIdentityVerificationDetailsByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetIdentityVerificationDetailsByIdResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/identity_verifications/{verification_id}'
    });
};

/**
 * Submitting the data for the final verification
 */
export const patchVerificationFlowSubmission = <ThrowOnError extends boolean = false>(options: Options<PatchVerificationFlowSubmissionData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchVerificationFlowSubmissionResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/identity_verifications/{verification_id}'
    });
};

/**
 * Submitting or Saving the steps data in to the system
 */
export const patchVerificationStepData = <ThrowOnError extends boolean = false>(options: Options<PatchVerificationStepDataData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchVerificationStepDataResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/identity_verifications/{verification_id}/steps/{step_id}'
    });
};

/**
 * Get all invoices
 */
export const getInvoices = <ThrowOnError extends boolean = false>(options: Options<GetInvoicesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetInvoicesResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/invoices'
    });
};

/**
 * Create Invoice
 */
export const createInvoice = <ThrowOnError extends boolean = false>(options: Options<CreateInvoiceData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateInvoiceResponse, CreateInvoiceError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/invoices'
    });
};

/**
 * Send invoice overdue reminders
 */
export const postInvoiceOverdueReminder = <ThrowOnError extends boolean = false>(options: Options<PostInvoiceOverdueReminderData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostInvoiceOverdueReminderResponse, PostInvoiceOverdueReminderError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/invoices/overdue-reminder'
    });
};

/**
 * Get Invoice by Payout Id
 */
export const getInvoiceByPayoutId = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceByPayoutIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetInvoiceByPayoutIdResponse, GetInvoiceByPayoutIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/invoices/payout/{payout_id}'
    });
};

/**
 * Get Invoice by Id
 */
export const getInvoiceById = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetInvoiceByIdResponse, GetInvoiceByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/invoices/{invoice_id}'
    });
};

/**
 * Update Invoice by Id
 */
export const updateInvoiceById = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceByIdData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateInvoiceByIdResponse, UpdateInvoiceByIdError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/invoices/{invoice_id}'
    });
};

/**
 * Enable multi currency support
 */
export const postMultiCurrencyEnable = <ThrowOnError extends boolean = false>(options: Options<PostMultiCurrencyEnableData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostMultiCurrencyEnableResponse, PostMultiCurrencyEnableError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/multi_currency'
    });
};

export const getCurrencyWallets = <ThrowOnError extends boolean = false>(options: Options<GetCurrencyWalletsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCurrencyWalletsResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/multi_currency/currency_wallet'
    });
};

export const postCurrencyWallet = <ThrowOnError extends boolean = false>(options: Options<PostCurrencyWalletData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCurrencyWalletResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/multi_currency/currency_wallet'
    });
};

/**
 * List all beneficial owners
 */
export const getBeneficialOwners = <ThrowOnError extends boolean = false>(options: Options<GetBeneficialOwnersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetBeneficialOwnersResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/multi_currency/owners'
    });
};

export const postBeneficialOwner = <ThrowOnError extends boolean = false>(options: Options<PostBeneficialOwnerData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostBeneficialOwnerResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/multi_currency/owners'
    });
};

export const deleteBeneficialOwner = <ThrowOnError extends boolean = false>(options: Options<DeleteBeneficialOwnerData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteBeneficialOwnerResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/multi_currency/owners/{owner_id}'
    });
};

export const patchBeneficialOwner = <ThrowOnError extends boolean = false>(options: Options<PatchBeneficialOwnerData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchBeneficialOwnerResponse, PatchBeneficialOwnerError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/multi_currency/owners/{owner_id}'
    });
};

/**
 * Retrieves partners based on customer id
 */
export const getPartners = <ThrowOnError extends boolean = false>(options: Options<GetPartnersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPartnersResponse, GetPartnersError, ThrowOnError>({
        ...options,
        url: '/api/v1/partners'
    });
};

/**
 * Create Partner
 */
export const createPartner = <ThrowOnError extends boolean = false>(options: Options<CreatePartnerData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreatePartnerResponse, CreatePartnerError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/partners'
    });
};

/**
 * Retrieves partner based on partner id
 */
export const getPartnerById = <ThrowOnError extends boolean = false>(options: Options<GetPartnerByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPartnerByIdResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/partners/{id}'
    });
};

/**
 * Updating partners based on partner id
 */
export const updatePartner = <ThrowOnError extends boolean = false>(options: Options<UpdatePartnerData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdatePartnerResponse, UpdatePartnerError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/partners/{id}'
    });
};

/**
 * Get all payouts
 */
export const getPayouts = <ThrowOnError extends boolean = false>(options: Options<GetPayoutsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPayoutsResponse, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/payouts'
    });
};

/**
 * Request Payouts
 */
export const postPayouts = <ThrowOnError extends boolean = false>(options: Options<PostPayoutsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostPayoutsResponse, PostPayoutsError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/payouts'
    });
};

/**
 * Payouts Preview
 */
export const postPayoutsPreview = <ThrowOnError extends boolean = false>(options: Options<PostPayoutsPreviewData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostPayoutsPreviewResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/payouts/preview'
    });
};

/**
 * Generate PDF with bank details
 */
export const generateBankDetailsPdf = <ThrowOnError extends boolean = false>(options: Options<GenerateBankDetailsPdfData, ThrowOnError>) => {
    return (options?.client ?? client).post<GenerateBankDetailsPdfResponse, GenerateBankDetailsPdfError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        responseType: 'blob',
        url: '/api/v1/public/bank-details/pdf'
    });
};

/**
 * Submit contact form data
 */
export const postContactForm = <ThrowOnError extends boolean = false>(options: Options<PostContactFormData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostContactFormResponse, PostContactFormError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/public/contact'
    });
};

/**
 * Get Fee details for Landing Page
 */
export const getGenericFees = <ThrowOnError extends boolean = false>(options: Options<GetGenericFeesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetGenericFeesResponse, GetGenericFeesError, ThrowOnError>({
        ...options,
        url: '/api/v1/public/fees'
    });
};

/**
 * Upload FIRC to Xflow to get costs incurred
 */
export const getCostsFromFirc = <ThrowOnError extends boolean = false>(options: Options<GetCostsFromFircData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetCostsFromFircResponse, GetCostsFromFircError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/octet-stream',
            ...options?.headers
        },
        url: '/api/v1/public/firc'
    });
};

/**
 * Get FIRC upload response by Id from DB
 */
export const getFircUploadResponseById = <ThrowOnError extends boolean = false>(options: Options<GetFircUploadResponseByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFircUploadResponseByIdResponse, GetFircUploadResponseByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/public/firc/{id}'
    });
};

/**
 * Email unsubscribe status of the email
 */
export const getEmailUnsubscribeStatus = <ThrowOnError extends boolean = false>(options: Options<GetEmailUnsubscribeStatusData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetEmailUnsubscribeStatusResponse, GetEmailUnsubscribeStatusError, ThrowOnError>({
        ...options,
        url: '/api/v1/public/unsubscribe/{hash}'
    });
};

/**
 * Email unsubscribe with reason
 */
export const postEmailUnsubscribe = <ThrowOnError extends boolean = false>(options: Options<PostEmailUnsubscribeData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostEmailUnsubscribeResponse, PostEmailUnsubscribeError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/public/unsubscribe/{hash}'
    });
};

/**
 * Get purpose codes for a customer
 */
export const getPurposeCodes = <ThrowOnError extends boolean = false>(options: Options<GetPurposeCodesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPurposeCodesResponse, GetPurposeCodesError, ThrowOnError>({
        ...options,
        url: '/api/v1/purpose_codes'
    });
};

/**
 * Add new purpose codes
 */
export const postPurposeCodes = <ThrowOnError extends boolean = false>(options: Options<PostPurposeCodesData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostPurposeCodesResponse, PostPurposeCodesError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/purpose_codes'
    });
};

/**
 * Retrieves users based on client user id & customer id
 */
export const getUsers = <ThrowOnError extends boolean = false>(options: Options<GetUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUsersResponse, GetUsersError, ThrowOnError>({
        ...options,
        url: '/api/v1/users'
    });
};

/**
 * Update User
 */
export const patchUser = <ThrowOnError extends boolean = false>(options: Options<PatchUserData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchUserResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/users'
    });
};

/**
 * Retrieves the existing user based on Cognito token or creates if not exists
 */
export const getOrCreateUser = <ThrowOnError extends boolean = false>(options: Options<GetOrCreateUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<GetOrCreateUserResponse, GetOrCreateUserError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/users'
    });
};

/**
 * Retrieves a user by their unique email
 */
export const getUserByEmail = <ThrowOnError extends boolean = false>(options: Options<GetUserByEmailData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserByEmailResponse, GetUserByEmailError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/email'
    });
};

/**
 * Synchronizes user information with Cognito and updates local database
 */
export const syncUser = <ThrowOnError extends boolean = false>(options: Options<SyncUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<SyncUserResponse, SyncUserError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/sync'
    });
};

/**
 * Deletes the secondary user's relation with Customer
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteUserResponse, DeleteUserError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}'
    });
};

/**
 * Retrieves a specific user by their ID within an organization context
 */
export const getUserById = <ThrowOnError extends boolean = false>(options: Options<GetUserByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserByIdResponse, GetUserByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}'
    });
};

/**
 * Retrieves an NFC card for a specific user
 */
export const getNfcCardDetails = <ThrowOnError extends boolean = false>(options: Options<GetNfcCardDetailsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetNfcCardDetailsResponse, GetNfcCardDetailsError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}/nfc-card'
    });
};

/**
 * Creates or updates an NFC card for a user
 */
export const createOrUpdateNfcCard = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateNfcCardData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateOrUpdateNfcCardResponse, CreateOrUpdateNfcCardError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/users/{user_id}/nfc-card'
    });
};

/**
 * Send OTP to the user
 */
export const sendOtp = <ThrowOnError extends boolean = false>(options: Options<SendOtpData, ThrowOnError>) => {
    return (options?.client ?? client).post<SendOtpResponse, unknown, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/utility/verification/send_otp'
    });
};

/**
 * Verify OTP sent by the user
 */
export const verifyOtp = <ThrowOnError extends boolean = false>(options: Options<VerifyOtpData, ThrowOnError>) => {
    return (options?.client ?? client).post<VerifyOtpResponse, VerifyOtpError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/utility/verification/verify_otp'
    });
};

/**
 * Handle webhook events from Xflow
 */
export const postXflowWebhook = <ThrowOnError extends boolean = false>(options: Options<PostXflowWebhookData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostXflowWebhookResponse, PostXflowWebhookError, ThrowOnError>({
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        },
        url: '/api/v1/webhooks/xflow'
    });
};